import styled from '@emotion/styled';

const ContentWrapper = styled('section')(({ theme }) => ({
  transition: theme.transitions.create()
}));

export default ContentWrapper;
